import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { BasemapContext, BASEMAP_STORAGE_KEY } from '@/lib/basemap'
import type { BasemapKind } from '@/lib/map'

function readInitialKind(): BasemapKind {
  if (typeof window === 'undefined') return 'street'
  try {
    const saved = localStorage.getItem(BASEMAP_STORAGE_KEY)
    if (saved === 'street' || saved === 'satellite') return saved
  } catch {
    // ignore
  }
  return 'street'
}

export function BasemapProvider({ children }: { children: ReactNode }) {
  const [kind, setKindState] = useState<BasemapKind>(() => readInitialKind())

  const setKind = useCallback((next: BasemapKind) => {
    setKindState(next)
    try {
      localStorage.setItem(BASEMAP_STORAGE_KEY, next)
    } catch {
      // ignore (private mode, quota)
    }
  }, [])

  const toggle = useCallback(() => {
    setKind(kind === 'street' ? 'satellite' : 'street')
  }, [kind, setKind])

  const value = useMemo(() => ({ kind, setKind, toggle }), [kind, setKind, toggle])

  return <BasemapContext.Provider value={value}>{children}</BasemapContext.Provider>
}
